/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳 
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
 */
function formatTimeToStr(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
  
    return fmt;
}
function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}
function getValue(Arr, haveDefault) {
    if (haveDefault) {
        var nameArr = ['请选择'];
    } else {
        var nameArr = [];
    }
    for (let i = 0; i < Arr.length; i++) {
        nameArr.push(Arr[i].name);
    }
    return nameArr;
}
//去重
function removal(brand, series, modelYear, vehicleModel, selledName) {
    if (!vehicleModel) {
        vehicleModel = ''
    }
    if (!selledName) {
        selledName = '';
    }
    if (!brand) {
        brand = '';
    }
    if (!series) {
        series = ''
    }
    if (!modelYear) {
        modelYear = ""
    } else {
        modelYear = modelYear + '款'
    }
    if (series && series.indexOf(brand) !== -1) {
        series = series.substr(0, series.indexOf(brand)) + series.substr(series.indexOf(brand) + brand.length, series.length)
    }
    if (vehicleModel && vehicleModel.indexOf(series) !== -1) {
        vehicleModel = vehicleModel.substr(0, vehicleModel.indexOf(series)) + vehicleModel.substr(vehicleModel.indexOf(series) + series.length, vehicleModel.length)
    }
    if (selledName && selledName.indexOf(vehicleModel) !== -1) {
        selledName = selledName.substr(0, selledName.indexOf(vehicleModel)) + selledName.substr(selledName.indexOf(vehicleModel) + vehicleModel.length, selledName.length)
    }
    return brand + ' ' + series + ' ' + modelYear + ' ' + vehicleModel + ' ' + selledName
}
function hasClass(el, className) {
    let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
    return reg.test(el.className)
}

function addClass(el, className) {
    if (hasClass(el, className)) {
        return
    }
    // localStorage.setItem('scrollTop',document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop)
    if (el.className === '') {
        el.className += className
    } else {
        let newClass = el.className.split(' ')
        newClass.push(className)
        el.className = newClass.join(' ')
    }
    // document.body.scrollTop = document.documentElement.scrollTop=localStorage.getItem('scrollTop');
}

function removeClass(el, className) {
    if (hasClass(el, className)) {
        el.className = el.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), '');
        // document.body.scrollTop = document.documentElement.scrollTop=localStorage.getItem('scrollTop');
    };
}

let scrollTop;

function setScrollTop(){
    scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    addClass(document.getElementsByTagName("body")[0], 'fixed');
    document.getElementsByTagName("body")[0].style.top = - scrollTop + "px";
    console.log(scrollTop)
}

function removeScrollTop(){
    removeClass(document.getElementsByTagName("body")[0], 'fixed');
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
    document.getElementsByTagName("body")[0].removeAttribute("style");
}
function preventFreezeAtTopOrBottomForIOS(isGetRefresher,scrollEle){
    let lastY = 0; // Needed in order to determine direction of scroll.
    scrollEle.addEventListener('touchstart', function(event) {
        lastY = event.touches[0].clientY;
    });
    //先移除监听事件
    scrollEle.removeEventListener('touchmove', function (event) {
        event.preventDefault();
    }, false);
    //再添加监听事件
    scrollEle.addEventListener('touchmove', function(event) {
            let top = event.touches[0].clientY;
            // Determine scroll position and direction.
            let scrollTop = scrollEle.scrollTop;
            // console.log("--scrollTop--" + scrollTop);
            let scrollHeight = scrollEle.scrollHeight;
            // console.log("--scrollHeight--" + scrollHeight);
            let clientHeight = scrollEle.clientHeight;
            // console.log("--clientHeight--" + clientHeight);
            let direction = (lastY - top) < 0 ? "up" : "down";
            // FIX IT!
            if (scrollTop == 0 && direction == "up") {
            console.log("--到顶部--");
            // Prevent scrolling up when already at top as this introduces a freeze.
            if(!isGetRefresher){//没有头部刷新的，需要设置防止头部freeze
                event.preventDefault();
            }
            } else if (scrollTop >= (scrollHeight - clientHeight) && direction == "down") {
            // Prevent scrolling down when already at bottom as this also introduces a freeze.
            event.preventDefault();
            console.log("--到底部--");
            }
            lastY = top;
        });
    
}

module.exports = {
    formatTimeToStr: formatTimeToStr,
    getValue: getValue,
    removal: removal,
    hasClass:hasClass,
    addClass:addClass,
    removeClass:removeClass,
    setScrollTop:setScrollTop,
    removeScrollTop:removeScrollTop,
    preventFreezeAtTopOrBottomForIOS
}


// WEBPACK FOOTER //
// ./src/assets/js/util.js